<div class="flex flex-col items-center justify-center h-full w-full text-gray-400 gap-3">
  <fa-icon [icon]="icon" class="text-4xl"></fa-icon>
  <span class="text-sm">{{ message }}</span>
  <ng-content></ng-content>
</div>
